module.exports = __webpack_public_path__ + "img/logo-super-jet-air.a28e5b23.png";